// extracted by mini-css-extract-plugin
export default {"fiscalYear":"fiscalYear_fiscalYear__lWHeC"};